<mat-chip-listbox>
  @for (team of teamsToRender; track trackByTeam(team)) {
    <mat-basic-chip [laTeamChipColor]="team.color">
      {{ showRole && team.role ? team.name + ' (' + team.role + ')' : team.name }}
    </mat-basic-chip>
  }
</mat-chip-listbox>

@if (teamsForMore.length) {
  <button class="more" mat-icon-button [matMenuTriggerFor]="moreTeamsMenu" (click)="$event.stopPropagation()">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
}

<mat-menu #moreTeamsMenu="matMenu" xPosition="after">
  <ng-template matMenuContent>
    @for (chip of teamsForMore; track chip.id) {
      <div class="chip-menu-item">
        <mat-basic-chip [laTeamChipColor]="chip.color">{{ chip.name }}</mat-basic-chip>
      </div>
    }
  </ng-template>
</mat-menu>
